<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
    export default {
        name: "Course-Level"
    }
</script>

<style scoped>

</style>
